import React from "react";
import { Navigate } from "react-router-dom";

import { useAuthentication } from "../../../hooks";

interface AuthenticationMixedRouteProps {
	readonly children: React.ReactNode;
}

export const AuthenticationMixedRoute: React.FC<AuthenticationMixedRouteProps> = ({ children }) => {
	const { ssoOnly } = useAuthentication();

	if (ssoOnly) {
		return <Navigate to="/" replace />;
	}

	return children;
};
